import React,{useState} from "react"
import { Link } from "@StarberryUtils"
import {Container,Row,Col } from 'react-bootstrap';
import propetyAbout from "../../../images/property-details/property-about.jpg"
import ScrollAnimation from 'react-animate-on-scroll';
import ReactMarkdown from "react-markdown"
import { AREA_GUIDES_PAGE_URL } from "@Components/common/site/constants";
import  './PropertyAbout.scss';
import PlayVideo from "../../Play/PlayVideo";
import { youtube_parser } from "./youtubeparser";

import { useQuery } from '@apollo/client';
import gql from "graphql-tag"

const SINGLE_AREA = gql`
query GetAreaDetails ($Prop_Postcode: String!){
    areaGuides (where:{Postcode_contains:$Prop_Postcode}) {
        Title
        Postcode
        URL
        Embed_Video_URL
        Intro_Content
        Tile_Image {
            url
        }
    }
}
`;

const PropertyAbout = ( props ) => {
    const [isPlay,setPlay] = useState(false);

    // Area guide
    const { loading, data } = useQuery(SINGLE_AREA, {
      variables: { Prop_Postcode: props.postcode }
    });
    // console.log("$$$", props)
    // Area guide

  return(
    <>
      {data && data.areaGuides && data.areaGuides.map((areaguide, key) => {
          var youtube_url = areaguide.Embed_Video_URL && youtube_parser(areaguide.Embed_Video_URL);
          if(key == 0) {
            return (
                    <>
                        <div className="property-about">
                            <Container>
                                <Row className="">
                                    <Col lg={6} className="img-zoom">
                                        <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                                            <figure><img src={propetyAbout} alt={areaguide.Title}/> { youtube_url ? <strong className="play-btn" onClick = { e => {setPlay(true)}} to="#"><i className="icon-play"></i></strong> : '' }</figure>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="about-info">
                                            <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={500}>
                                                <h4>About {areaguide.Title} </h4>
                                                <p className="desc desc-txt rich-text-editer-block"><ReactMarkdown  source={areaguide.Intro_Content} allowDangerousHtml /></p>
                                                <Link to={AREA_GUIDES_PAGE_URL.alias+'/'+areaguide.URL} className="link-text"> <span className="btn-arrow"><i className="icon-arrow"></i></span> {areaguide.Title} Guide</Link>
                                            </ScrollAnimation>
                                        </div>
                                    </Col>
                                </Row>
                                {
                                    youtube_url ? 
                                    <PlayVideo
                                        isOpen = { isPlay } 
                                        isCloseFunction = { setPlay }
                                        videoId={youtube_url}
                                        isAutoPlay={1}
                                    />
                                    : ''
                                }
                            </Container>
                        </div>
                    </>
                )
        }
        })}
    </>
    )
  }



export default PropertyAbout